// WhatsAppWrapper.jsx
import { lazy, Suspense, useEffect, useState } from "react";
const WhatsAppWidget = lazy(() => import("./WhatsAppWidget"));

export default function WhatsAppWrapper() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 2000); // 2s después del render
    return () => clearTimeout(timeout);
  }, []);

  return (
    show && (
      <Suspense fallback={null}>
        <WhatsAppWidget />
      </Suspense>
    )
  );
}